import React from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from '@components/atoms'

import { useAppSelector, useAppDispatch, authActions } from '@redux/index'

interface PropsType {
	to?: string
	isShouldLoginPage?: boolean
	children: JSX.Element
}

export const LoginAccessGuard: React.FC<PropsType> = props => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// local storage
	const storageIsLogin: boolean =
		localStorage.getItem('isLogin') === 'true' ? true : false

	// redux state
	const currentPath: string = useAppSelector(state => state.route.currentPath)
	const isReduxLoading: boolean = useAppSelector(state => state.config.isLoading)
	const isReduxLogin: boolean = useAppSelector(state => state.auth.isLogin as boolean)

	// variables
	const isShouldLoginPage: boolean = props.isShouldLoginPage ?? true
	const to = props.to || '/auth/loading'
	const isLogin: boolean = isReduxLogin && storageIsLogin
	const isNavigate: boolean =
		(isShouldLoginPage === false && isLogin === true) ||
		(isShouldLoginPage === true && isLogin === false)

	// state
	const [isCheckingAccessTokenNow, setIsCheckingAccessTokenNow] = React.useState(false)

	let timeout: ReturnType<typeof setTimeout>

	React.useEffect(() => {
		if (isShouldLoginPage) {
			if (!isCheckingAccessTokenNow) {
				reduxDispatch(authActions.TRIGGER_CHECK_ACCESS_TOKEN(true))
				setIsCheckingAccessTokenNow(true)
				timeout = setTimeout(() => {
					setIsCheckingAccessTokenNow(false)
					clearTimeout(timeout)
				}, 500)
			}
		}
	}, [currentPath])

	return (
		<>
			{isReduxLoading ? (
				<Spinner />
			) : isNavigate ? (
				<Navigate to={to} replace={true} />
			) : (
				props.children
			)}
		</>
	)
}
